module.exports = __webpack_public_path__ + "img/ctrl-p-stub-mid--.318ab964.svg";